import en from "./en/translation.json";
import az from "./az/translation.json";
import nl from "./nl/translation.json";
import ar from "./ar/translation.json";
import ja from "./ja/translation.json";
import de from "./de/translation.json";
import es from "./es/translation.json";
import fr from "./fr/translation.json";
import it from "./it/translation.json";
import ka from "./ka/translation.json";
import ko from "./ko/translation.json";
import pl from "./pl/translation.json";
import pt from "./pt/translation.json";
import ro from "./ro/translation.json";
import ru from "./ru/translation.json";
import tr from "./tr/translation.json";
import uk from "./uk/translation.json";
import vi from "./vi/translation.json";
import zh from "./zh/translation.json";
import zu from "./zu/translation.json";

export const config = {
  defaultNS: "translation",
  resources: {
    en: en,
    nl: nl,
    az: az,
    ar: ar,
    ja: ja,
    de: de,
    es: es,
    fr: fr,
    it: it,
    ka: ka,
    ko: ko,
    pl: pl,
    pt: pt,
    ro: ro,
    ru: ru,
    tr: tr,
    uk: uk,
    vi: vi,
    zh: zh,
    zu: zu,
  },
  lng: "en",
  fallbackLng: "en",
};
